var map = {
	"./anvyl.png": "vFG3",
	"./attentive.png": "D8MX",
	"./bolt.png": "sLBe",
	"./carthook.png": "Y/eq",
	"./cartkit.png": "HiZJ",
	"./chargebee.png": "04+R",
	"./clyde.png": "sekM",
	"./daasity.png": "0YZM",
	"./easypost.png": "KzpX",
	"./emarsys.png": "PKak",
	"./emotive.png": "YpBZ",
	"./emotive_old.png": "3FDM",
	"./expivi.png": "GYqg",
	"./extend.png": "gtdH",
	"./fenix commerce.png": "yPIQ",
	"./findify.png": "LgBf",
	"./gembah.png": "4AXi",
	"./glew.io.png": "oqD5",
	"./gorgias.png": "a1Qs",
	"./happy returns.png": "Hn/N",
	"./intellimize.png": "he6c",
	"./judge.me.png": "OIdA",
	"./justuno.png": "HpAP",
	"./klaviyo.png": "K/rH",
	"./klevu.png": "DbW3",
	"./liverecover.png": "HPrb",
	"./loop returns.png": "sBOv",
	"./loox.png": "eT7K",
	"./loyaltylion.png": "hiX5",
	"./malomo.png": "9yxV",
	"./namogoo.png": "DmtV",
	"./nosto.png": "5+YI",
	"./ns8.png": "8DeF",
	"./oberlo.png": "sicc",
	"./okendo.png": "GiZv",
	"./omnisend.png": "8Nzc",
	"./onesignal.png": "g64f",
	"./peel insights.png": "rTNC",
	"./postscript.png": "eaG1",
	"./privy.png": "RWJj",
	"./proof.png": "DiQC",
	"./pushnami.png": "SsIT",
	"./pushowl.png": "N7JP",
	"./recharge.png": "jbVS",
	"./retention rocket.png": "J2LF",
	"./rewind backups.png": "zbym",
	"./rise.ai.png": "5f1B",
	"./route.png": "e13D",
	"./sendcloud.png": "djDa",
	"./shogun.png": "J+aF",
	"./sleeknote.png": "SfbE",
	"./smartrmail.png": "Rnb8",
	"./smile.io.png": "AgHh",
	"./smsbump.png": "Dvf+",
	"./soundcommerce.png": "CpGm",
	"./sourcify.png": "BRuD",
	"./spocket.png": "+Epy",
	"./stamped.io.png": "GxBc",
	"./tapcart.png": "vc+h",
	"./tone sms.png": "3NDG",
	"./trbo.png": "5MBh",
	"./voyage sms.png": "6RGG",
	"./xentral.png": "07+h",
	"./yaguara.png": "8teD",
	"./yotpo.png": "IINL",
	"./yottaa.png": "kBsK",
	"./zenloop.png": "7Q4R",
	"./zigzag.png": "Lz4v"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YYPR";